/* Incrementium Listicle JS — Tracking + Interactions */
(function() {
  'use strict';

  var section = document.querySelector('.inc-relationship-10-reasons');
  if (!section) return;

  var webhookUrl = section.querySelector('[data-webhook]')
    ? section.querySelector('[data-webhook]').dataset.webhook
    : (document.querySelector('.inc-relationship-10-reasons').closest('[id]')
      ? '' : '');

  // Try getting webhook from section settings
  try {
    var schemaEl = section.closest('section') || section;
    var settingsScript = schemaEl.querySelector('script[type="application/json"]');
    if (settingsScript) {
      var s = JSON.parse(settingsScript.textContent);
      if (s.webhook_url) webhookUrl = s.webhook_url;
    }
  } catch(e) {}

  // Tracking
  function track(event, data) {
    if (!webhookUrl) return;
    var payload = Object.assign({
      event: event,
      page: window.location.pathname,
      timestamp: new Date().toISOString(),
      sessionId: getSessionId()
    }, data || {});
    var img = new Image();
    img.src = webhookUrl + '?data=' + encodeURIComponent(JSON.stringify(payload)) + '&t=' + Date.now();
  }

  function getSessionId() {
    var sid = sessionStorage.getItem('inc_sid');
    if (!sid) { sid = 'sid_' + Math.random().toString(36).substr(2, 9); sessionStorage.setItem('inc_sid', sid); }
    return sid;
  }

  // Page view
  track('page_view');

  // Scroll depth
  var scrollMarks = [25, 50, 75, 100];
  var scrollFired = {};
  window.addEventListener('scroll', function() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    var pct = Math.round((window.scrollY / h) * 100);
    scrollMarks.forEach(function(mark) {
      if (pct >= mark && !scrollFired[mark]) {
        scrollFired[mark] = true;
        track('scroll_depth', { depth: mark });
      }
    });
  }, { passive: true });

  // Reason views (intersection observer)
  var reasons = section.querySelectorAll('.inc-relationship-10-reasons__reason');
  if (window.IntersectionObserver) {
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var num = e.target.dataset.reason;
          track('reason_view', { reason: num });
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    reasons.forEach(function(r) { obs.observe(r); });
  }

  // CTA clicks
  section.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link && (link.classList.contains('inc-relationship-10-reasons__reason-cta') || link.classList.contains('inc-relationship-10-reasons__hero-cta') || link.classList.contains('inc-relationship-10-reasons__offer-cta'))) {
      var reason = link.closest('.inc-relationship-10-reasons__reason');
      track('cta_click', {
        reason: reason ? reason.dataset.reason : 'offer',
        text: link.textContent.trim().substring(0, 50),
        url: link.href
      });
    }
  });

  // Time on page
  var startTime = Date.now();
  window.addEventListener('beforeunload', function() {
    track('time_on_page', { seconds: Math.round((Date.now() - startTime) / 1000) });
  });

  // FAQ accordion
  var faqBtns = section.querySelectorAll('.inc-relationship-10-reasons__faq-q');
  faqBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      var answer = btn.nextElementSibling;
      if (answer) answer.hidden = expanded;
      track('faq_toggle', { question: btn.textContent.trim().substring(0, 60) });
    });
  });

  // Countdown timer
  var countdownEl = section.querySelector('.inc-relationship-10-reasons__countdown');
  if (countdownEl) {
    var totalSeconds = parseInt(countdownEl.dataset.hours || 4) * 3600;
    var stored = sessionStorage.getItem('inc_countdown_end');
    var endTime;
    if (stored) {
      endTime = parseInt(stored);
    } else {
      endTime = Date.now() + totalSeconds * 1000;
      sessionStorage.setItem('inc_countdown_end', endTime);
    }
    function updateCountdown() {
      var remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      countdownEl.textContent = String(h).padStart(2,'0') + ':' + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
      if (remaining > 0) requestAnimationFrame(function() { setTimeout(updateCountdown, 1000); });
    }
    updateCountdown();
  }

  // Sticky CTA bar — show after scrolling past hero
  var stickyBar = section.querySelector('.inc-relationship-10-reasons__sticky-bar');
  if (stickyBar) {
    var hero = section.querySelector('.inc-relationship-10-reasons__hero');
    var stickyShown = false;
    var showThreshold = hero ? hero.offsetTop + hero.offsetHeight + 200 : 400;
    window.addEventListener('scroll', function() {
      if (window.scrollY > showThreshold && !stickyShown) {
        stickyBar.classList.add('inc-relationship-10-reasons__sticky-bar--visible');
        stickyShown = true;
      } else if (window.scrollY <= showThreshold && stickyShown) {
        stickyBar.classList.remove('inc-relationship-10-reasons__sticky-bar--visible');
        stickyShown = false;
      }
    }, { passive: true });
  }
})();